import { render } from "./AttendanceManagement.vue?vue&type=template&id=1a906cd2"
import script from "./AttendanceManagement.vue?vue&type=script&lang=js"
export * from "./AttendanceManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__